import { useEffect, useState } from "react";
import { api } from "@/App";
import { useNavigate } from "react-router-dom";
import { Sparkles, RefreshCw, ArrowRight } from "lucide-react";

const DailyBriefing = () => {
  const navigate = useNavigate();
  const [briefing, setBriefing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async (force = false) => {
    if (force) setRefreshing(true);
    try {
      const res = await api.post("/tutor/daily-briefing", { force_refresh: force });
      setBriefing(res);
    } catch (e) {
      console.error("Briefing load failed", e);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => { load(false); }, []);

  if (loading) {
    return (
      <div className="glass rounded-2xl p-5 border border-border animate-pulse h-28" />
    );
  }
  if (!briefing) return null;

  return (
    <div
      data-testid="daily-briefing"
      className="glass rounded-2xl p-5 md:p-6 border border-primary/30 bg-gradient-to-br from-primary/10 via-transparent to-transparent"
    >
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs uppercase tracking-wider text-primary font-semibold">
              Today&apos;s briefing
            </p>
            <button
              data-testid="briefing-refresh-btn"
              onClick={() => load(true)}
              disabled={refreshing}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <RefreshCw className={`w-3.5 h-3.5 ${refreshing ? "animate-spin" : ""}`} />
            </button>
          </div>
          <p className="text-sm md:text-base mb-3 leading-relaxed">{briefing.message}</p>
          {briefing.focus_subject_id && (
            <button
              data-testid="briefing-focus-btn"
              onClick={() => navigate(`/practice/${briefing.focus_subject_id}`)}
              className="inline-flex items-center gap-2 text-xs text-primary font-medium hover:underline"
            >
              Practice {briefing.focus_subject} now
              <ArrowRight className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailyBriefing;
